const _temp0 = require("./001-001.json");
const _temp1 = require("./001-002.json");
const _temp2 = require("./001-003.json");
const _temp3 = require("./001-004.json");
const _temp4 = require("./001-005.json");
const _temp5 = require("./001-006.json");
const _temp6 = require("./001-007.json");
const _temp7 = require("./001-008.json");
const _temp8 = require("./001-009.json");
const _temp9 = require("./001-010.json");
const _temp10 = require("./001-011.json");
const _temp11 = require("./001.json");
module.exports = {
  "001-001": _temp0,
  "001-002": _temp1,
  "001-003": _temp2,
  "001-004": _temp3,
  "001-005": _temp4,
  "001-006": _temp5,
  "001-007": _temp6,
  "001-008": _temp7,
  "001-009": _temp8,
  "001-010": _temp9,
  "001-011": _temp10,
  "001": _temp11
}